import a from"react";import{styles as r}from"./Overlay.css.vanilla.js";var e=function(e){var l=e.children,o=e.ariaLabel,i=e.role,t=e.show,c=e.onClick;return a.createElement("div",{"aria-label":o,className:r.overlay({show:t}),role:i||"dialog",onClick:c},l)};export{e as default};
//# sourceMappingURL=Overlay.js.map
